// Mock data for Adeel's AI/ML Engineer Portfolio

export const personalInfo = {
  name: "Adeel Ahmed",
  title: "AI/ML Engineer",
  tagline: "Building Intelligent Solutions That Transform Automation & Business Intelligence",
  profileImage: "https://customer-assets.emergentagent.com/job_5c92a49b-cad8-4b6e-9728-f2f514e5c42e/artifacts/uconjkjt_image.png",
  email: "adeelahmedsatti32@gmail.com",
  phone: "+923145053820",
  location: "Rawalpindi, Pakistan",
  linkedin: "https://www.linkedin.com/in/adeel-ahmed-satti-a3792027b",
  github: "https://github.com/adeelahmed1293",
  resume: "/resume-adeel-satti.pdf"
};

export const aboutMe = {
  description: "Passionate AI/ML Engineer specializing in intelligent automation and business intelligence solutions. Currently pursuing BSCS at Institute of Space Technology, I combine cutting-edge AI frameworks with practical applications that drive real business value. From advanced RAG systems to agentic AI workflows, I build intelligent solutions that solve complex problems across various domains.",
  highlights: [
    "10+ AI/ML projects with production-ready implementations",
    "Expert in modern AI frameworks like LangChain, n8n, and MCP servers", 
    "Full-stack developer with comprehensive tech stack mastery",
    "Active contributor to AI community and open-source projects"
  ]
};

export const skills = {
  "Languages & Web": [
    "Python", "JavaScript", "PHP", "HTML5", "CSS3", "Tailwind CSS",
    "React.js", "Streamlit", "HTML",
  ],
  "Machine Learning & AI": [
    "Scikit-learn", "TensorFlow", "Keras", "HuggingFace Transformers",
    "Deep Learning", "CNN", "NLP",
  ],
  "Agentic AI & LLMs": [
    "LangChain", "LangGraph", "CrewAI", "Agno AI", "FastMCP", "MCP Servers",
    "LiveKit Agents", "Agentic AI", "Google ADK", "OpenAI SDK",
    "FAISS", "Embeddings", "LLM Evaluation", "RAG Pipelines",
  ],
  "Backend & APIs": [
    "FastAPI", "Express.js", "NestJS", "Node.js", "Golang", "REST APIs",
    "GraphQL", "Uvicorn", "Webhooks", "Authentication", "Twilio",
  ],
  "Databases & Storage": [
    "MongoDB", "MySQL", "PostgreSQL", "SQLite", "Qdrant", "Pinecone", "XAMPP",
  ],
  "Automation & Tools": [
    "n8n", "make.com", "LiveKit Agents",
    "Git", "GitHub", "GitLab", "Docker", "Vercel", "VS Code", "Jupyter Notebook",
  ]
};

export const projects = [
  {
    id: 1,
    title: "Hospital AI Voice Receptionist",
    description: "Voice AI system that answers real inbound phone calls, books appointments, checks doctor availability, and routes emergencies in real time using LiveKit Agents and Twilio Voice.",
    image: "/livekit.png",
    technologies: ["LiveKit Agents", "Twilio Voice", "FastAPI", "MongoDB", "Groq LLM", "Deepgram STT", "Cartesia TTS", "SIP Trunking"],
    github: "https://github.com/adeelahmed1293/Inbounnd_Caller_Hospital_receptionnist",
    demo: "https://www.linkedin.com/posts/adeel-ahmed-satti-a3792027b_voiceai-python-livekit-activity-7436310722437079040-OAr7?utm_source=share&utm_medium=member_desktop&rcm=ACoAAERNQ8sB0HtPYN2Sl5pdUz9K0syCHBzNjhU",
    features: [
      "Real inbound phone call handling via Twilio SIP",
      "Appointment booking with MongoDB integration",
      "Doctor availability and schedule lookup",
      "Emergency detection and routing"
    ]
  },
  {
    id: 2,
    title: "AI Coder & Reviewer",
    description: "Intelligent code generation and analysis platform powered by LangGraph and LangChain. Features real-time code review, automated debugging, and smart suggestions for developers.",
    image: "https://customer-assets.emergentagent.com/job_portfolio-dev-adeel/artifacts/he0rydlr_Screenshot%202025-09-09%20092400.png",
    technologies: ["LangGraph", "FastAPI", "React", "LangChain", "Checkpointor", "MongoDB"],
    github: "https://github.com/adeelahmed1293/Coder",
    demo: "https://coder-mver-git-main-adeel1293satti-3082s-projects.vercel.app/",
    features: [
      "AI-powered code generation",
      "Smart code review and analysis",
      "Real-time debugging assistance",
      "Multi-language support"
    ]
  },
  {
    id: 3,
    title: "RAG PDF Insights",
    description: "Advanced Retrieval Augmented Generation system using LangChain and Llama 3. Multi-document RAG with intelligent embeddings and n8n workflow integration.",
    image: "https://customer-assets.emergentagent.com/job_portfolio-dev-adeel/artifacts/7knze5f0_Screenshot%202025-09-09%20091450.png",
    technologies: ["LangChain", "Llama 3", "FAISS", "Transformers", "RAG", "n8n", "Embeddings"],
    github: "https://github.com/adeelahmed1293/generative_ai",
    demo: "https://www.linkedin.com/posts/adeel-ahmed-satti-a3792027b_rag-n8n-ai-activity-7349291700202143745-uFRx",
    features: [
      "Multi-document RAG system",
      "Intelligent document processing",
      "Advanced embeddings integration",
      "n8n workflow automation"
    ]
  },
  {
    id: 4,
    title: "Brain Tumor Detection",
    description: "CNN-based deep learning model for medical imaging analysis. Achieves 94% accuracy in brain tumor detection using MRI scans with an intuitive Streamlit interface.",
    image: "https://customer-assets.emergentagent.com/job_5c92a49b-cad8-4b6e-9728-f2f514e5c42e/artifacts/f3vg5jk8_Screenshot%202025-09-08%20223046.png",
    technologies: ["TensorFlow", "Keras", "Streamlit", "CNN", "Computer Vision", "Medical AI"],
    github: "https://github.com/adeelahmed1293/Machine-Learning-projects-/tree/main/Brain_Tumor_Prediction",
    demo: "https://www.linkedin.com/posts/adeel-ahmed-satti-a3792027b_deeplearning-brain-streamlit-activity-7246326119023472640-6pf_",
    features: [
      "Real-time MRI scan analysis",
      "4-class tumor classification",
      "Interactive web interface",
      "High accuracy prediction (94%)"
    ]
  },
  {
    id: 5,
    title: "AI HR Assistant",
    description: "Automated candidate shortlisting system using n8n workflow automation. Integrates MCP servers, classifiers, and Google Drive tools for intelligent HR processing.",
    image: "https://customer-assets.emergentagent.com/job_portfolio-dev-adeel/artifacts/0mkavudw_Screenshot%202025-09-08%20230602.png",
    technologies: ["n8n", "MCP Server", "Classifier", "Drive Tools", "Gmail Tools", "AI Automation"],
    github: "#",
    demo: "https://www.linkedin.com/posts/adeel-ahmed-satti-a3792027b_ai-hr-automation-activity-7350185407092768768-35_y",
    features: [
      "Automated candidate shortlisting",
      "Resume analysis and scoring",
      "Email automation workflow",
      "Google Drive integration"
    ]
  },
  {
    id: 6,
    title: "LinkedIn Post Generator",
    description: "Automated content creation tool with MCP server integration. Streamlines LinkedIn posting with AI-generated content tailored for professional engagement.",
    image: "https://customer-assets.emergentagent.com/job_5c92a49b-cad8-4b6e-9728-f2f514e5c42e/artifacts/e8bla1ne_Screenshot%202025-09-08%20222450.png",
    technologies: ["MCP Server", "MCP Use", "Selenium", "Python", "AI Content Generation"],
    github: "https://github.com/adeelahmed1293/Mcp-use-linkedin-custom-Server",
    demo: "https://www.linkedin.com/posts/adeel-ahmed-satti-a3792027b_ai-automation-langchain-activity-7360892737040101377-doq2",
    features: [
      "AI-powered content generation",
      "MCP protocol integration",
      "LinkedIn platform optimization",
      "Automated posting workflow"
    ]
  },
  {
    id: 7,
    title: "University LMS Platform",
    description: "Comprehensive Learning Management System built with MERN stack. Features course management, student enrollment, assignment tracking, and interactive learning tools.",
    image: "https://customer-assets.emergentagent.com/job_portfolio-dev-adeel/artifacts/71s72sjd_Screenshot%202025-09-08%20224804.png",
    technologies: ["MongoDB", "Express.js", "React", "Node.js", "JWT", "Material-UI"],
    github: "https://github.com/adeelahmed1293/LMS_university",
    demo: "https://www.linkedin.com/posts/saad-ali-248492363_frontenddevelopment-html-css-activity-7350064360125251584-DeKM",
    features: [
      "Course management system",
      "Student enrollment portal",
      "Assignment submission tracking",
      "Interactive learning dashboard"
    ]
  },
  {
    id: 8,
    title: "Multiple Disease Detection",
    description: "Comprehensive analytics platform using statistical machine learning. Predicts multiple diseases including heart disease, diabetes, and Parkinson's with high accuracy.",
    image: "https://customer-assets.emergentagent.com/job_5c92a49b-cad8-4b6e-9728-f2f514e5c42e/artifacts/wwo4twhf_Screenshot%202025-09-08%20224256.png",
    technologies: ["Scikit-learn", "Streamlit", "Statistical ML", "Python", "Healthcare Analytics"],
    github: "https://github.com/adeelahmed1293/Machine-Learning-projects-/tree/main/Multiple_disease_detection",
    demo: "https://www.linkedin.com/posts/adeel-ahmed-satti-a3792027b_introducing-my-latest-project-multiple-disease-activity-7242009024357945344-Mw-C",
    features: [
      "Multi-disease prediction system",
      "Heart disease detection",
      "Diabetes risk assessment",
      "Parkinson's disease screening"
    ]
  }
];

export const experience = [
  {
    role: "AI / ML Intern",
    company: "Developer Hub",
    location: "Remote",
    duration: "Jul 2025 - Aug 2025",
    type: "Internship",
    current: false,
    gradient: "from-teal-500 to-emerald-600",
    tags: ["Python", "TensorFlow", "Keras", "CNNs", "Scikit-learn", "Streamlit"],
    highlights: [
      "Applied statistical machine learning fundamentals — data preprocessing, feature engineering, model evaluation, and supervised learning techniques on real datasets.",
      "Built a Brain Tumor Detection system using CNNs with TensorFlow and Keras, achieving 94% accuracy on MRI datasets for 4-class tumor classification through data augmentation and dropout regularisation.",
      "Designed, built, and deployed multiple Machine Learning and Deep Learning solutions using Streamlit, enabling end users to interact with predictive models through intuitive web-based interfaces and real-time inference workflows.",
    ],
  },
  {
    role: "Backend Developer Intern",
    company: "O'Cyber",
    location: "Onsite",
    duration: "Jul 2026 - Present",
    type: "Internship",
    current: true,
    gradient: "from-teal-500 to-emerald-500",
    tags: ["NestJS", "GraphQL", "Golang", "Auth", "PostgreSQL", "REST APIs"],
    highlights: [
      "Developing scalable backend services for an Internet Service Provider (ISP) platform using NestJS, GraphQL, and Go (Golang).",
      "Designing and implementing GraphQL APIs, business logic, authentication, and modular backend architecture following enterprise development practices.",
      "Collaborating with cross-functional teams to build, integrate, and optimize backend services with a focus on performance, maintainability, and scalability.",
    ],
  },
];

export const education = [
  {
    degree: "Bachelor of Science in Computer Science (BSCS)",
    institution: "Institute of Space Technology (KICSIT Campus)",
    location: "Kahuta, Pakistan", 
    duration: "2023 - 2027",
    status: "Currently Pursuing",
    highlights: [
      "Specialized in Artificial Intelligence and Machine Learning",
      "Focus on Intelligent Automation and AI Systems",
      "Active in research projects and technical competitions"
    ]
  },
  {
    degree: "FSC (ICS)", 
    institution: "Military College Murree",
    location: "Murree, Pakistan",
    duration: "2020 - 2022", 
    status: "Completed",
    highlights: [
      "Strong foundation in Mathematics and Physics",
      "Leadership and disciplinary training",
      "Academic excellence recognition"
    ]
  }
];

export const contact = {
  email: "adeelahmedsatti32@gmail.com",
  phone: "+923145053820",
  location: "Rawalpindi, Pakistan",
  linkedin: "https://www.linkedin.com/in/adeel-ahmed-satti-a3792027b",
  github: "https://github.com/adeelahmed1293",
  availability: "Available for freelance projects and full-time opportunities"
};
